(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pestanas-producto-json"] && !Shopify.designMode) return;
  try {
    
  class ProductTabsSection {
    constructor(container) {
      this.container = container;
      this.tabs = this.container.querySelectorAll('.tab-producto-button');
      this.panes = this.container.querySelectorAll('.tab-producto-pane');
      this.init();
    }
    init() {
      if (!this.tabs.length) return;
      this.tabs.forEach(tab => {
        tab.addEventListener('click', (event) => {
          this.activateTab(event.currentTarget);
        });
      });
    }
    activateTab(tab) {
      this.tabs.forEach(item => {
        item.classList.remove('active');
        item.setAttribute('aria-selected', 'false');
      });
      this.panes.forEach(pane => {
        pane.classList.remove('active');
      });
      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');
      const targetPaneId = tab.getAttribute('aria-controls');
      this.container.querySelector(`#${targetPaneId}`).classList.add('active');
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.tabs-producto-container').forEach(container => {
      new ProductTabsSection(container);
    });
  });

  const moneyFormatter = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' });
  let pricesCache = null;

  function normalizeTechniqueKey(value) {
    return String(value || '').trim().toUpperCase();
  }

  function toNumber(value) {
    if (value === null || value === undefined || value === '') return NaN;
    const normalized = String(value).replace(',', '.').trim();
    const n = Number(normalized);
    return Number.isFinite(n) ? n : NaN;
  }

  function formatMoney(value) {
    const n = Number(value) || 0;
    return moneyFormatter.format(n);
  }

  // pricesAssetUrls / fetchPricesWithFallback: copia de calculator.js.liquid.
  // Esta sección se bundlea aparte (Shopify {% javascript %}) y puede ejecutarse
  // antes de que calculator.js las exponga en window, así que se duplican aquí.
  // fetchPricesWithFallback diverge de la copia compartida: aquí cada intento lleva
  // su propio timeout de 8s con AbortController, restaurando el comportamiento
  // original de esta sección (antes un fetch colgado dejaba la pestaña en
  // "Cargando tarifas..." para siempre). También usa cache: 'no-store',
  // comportamiento original de Markegifts.
  function pricesAssetUrls(legacyUrl, vendor) {
    const v = String(vendor || '');
    const map = [
      [/makito/i, 'makito'],
      [/roly|stamina/i, 'roly'],
      [/cifra/i, 'cifra'],
      [/pf\s*concept/i, 'pfconcept'],
      [/mid\s*ocean/i, 'midocean'],
    ];
    const hit = map.find(([re]) => re.test(v));
    if (!hit || !/prices\.json/.test(String(legacyUrl || ''))) return [legacyUrl];
    return [String(legacyUrl).replace(/prices\.json/, 'prices-' + hit[1] + '.json'), legacyUrl];
  }

  async function fetchPricesWithFallback(urls) {
    for (const url of urls) {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 8000);
      try {
        const r = await fetch(url, { cache: 'no-store', signal: controller.signal });
        if (!r.ok) continue;
        const json = await r.json();
        if (Array.isArray(json) && json.length) return json;
      } catch (e) { /* siguiente URL */ }
      finally {
        clearTimeout(timeoutId);
      }
    }
    return [];
  }

  async function loadPricesJson() {
    if (Array.isArray(pricesCache)) return pricesCache;

    const assetUrl = window.pricesAssetUrl || '';
    if (!assetUrl) {
      console.error('pricesAssetUrl no disponible en window.');
      pricesCache = [];
      return pricesCache;
    }

    try {
      const urls = pricesAssetUrls(assetUrl, window.productVendor);
      pricesCache = await fetchPricesWithFallback(urls);
      // DTF ampliado: si la ficha ofrece DTF1 (100901) y la tarifa del proveedor no lo trae, se toma de la general
      if (urls.length > 1 && document.querySelector('[data-tech-ref="100901"]') && !pricesCache.some((x) => String(x && x.technique_ref) === '100901')) {
        const general = await fetchPricesWithFallback([assetUrl]);
        pricesCache = pricesCache.concat(general.filter((x) => String(x && x.technique_ref) === '100901'));
      }
    } catch (error) {
      console.error('No se pudo cargar prices.json para tabla de marcaje:', error);
      pricesCache = [];
    }

    return pricesCache;
  }

  function findPriceConfig(pricesJson, techniqueRef) {
    const key = normalizeTechniqueKey(techniqueRef);
    if (!key || !Array.isArray(pricesJson)) return null;

    return pricesJson.find((item) => {
      const itemCode = normalizeTechniqueKey(item && item.code ? item.code : '');
      const itemRef = normalizeTechniqueKey(item && item.technique_ref ? item.technique_ref : '');
      return itemCode === key || itemRef === key;
    }) || null;
  }

  function inferTechniqueRefFromButton(button) {
    if (!button) return '';

    const fromData = button.dataset && button.dataset.techRef ? button.dataset.techRef : '';
    if (fromData) return fromData;

    const txt = (button.textContent || '').trim();
    const bracketMatch = txt.match(/\[([^\]]+)\]/);
    if (bracketMatch && bracketMatch[1]) return bracketMatch[1];

    return txt;
  }

  function buildPriceRows(config, button) {
    if (!config || typeof config !== 'object') return [];

    const rows = [];
    const cliche = Number(config.cliche) || 0;
    const maxColors = button && button.dataset && button.dataset.techColors ? button.dataset.techColors : '-';

    const widthMm = toNumber(button && button.dataset ? button.dataset.techWidth : '');
    const heightMm = toNumber(button && button.dataset ? button.dataset.techHeight : '');
    let areaText = '-';
    if (Number.isFinite(widthMm) && Number.isFinite(heightMm) && widthMm > 0 && heightMm > 0) {
      const areaCm2 = (widthMm * heightMm) / 100;
      areaText = areaCm2.toFixed(2);
    }

    for (let i = 1; i <= 20; i++) {
      const qty = Number(config[`section_${i}`]);
      const unitPrice = Number(config[`price_${i}`]);
      if (!Number.isFinite(qty) || qty <= 0) continue;
      if (!Number.isFinite(unitPrice) || unitPrice <= 0) continue;

      rows.push({
        cantidad: `${qty}+`,
        precio: formatMoney(unitPrice),
        cliche: formatMoney(cliche),
        colores: maxColors,
        area: areaText
      });
    }

    return rows;
  }

  function renderRows(tbody, rows) {
    if (!tbody) return;

    if (!rows.length) {
      tbody.innerHTML = '<tr><td colspan="5">No hay tarifas disponibles para esta técnica.</td></tr>';
      return;
    }

    tbody.innerHTML = rows.map((row) => `
      <tr>
        <td>${row.cantidad}</td>
        <td>${row.precio}</td>
        <td>${row.cliche}</td>
        <td>${row.colores}</td>
        <td>${row.area}</td>
      </tr>
    `).join('');
  }

  async function fillMarkingTable(button) {
    if (!button) return;

    const tableDiv = button.nextElementSibling;
    if (!tableDiv) return;

    const tbody = tableDiv.querySelector('.marcaje-precios-body') || tableDiv.querySelector('tbody');
    if (!tbody) return;

    tbody.innerHTML = '<tr><td colspan="5">Cargando tarifas...</td></tr>';

    try {
      const techniqueRef = inferTechniqueRefFromButton(button);
      const prices = await loadPricesJson();
      const config = findPriceConfig(prices, techniqueRef);
      if (!config) {
        tbody.innerHTML = `<tr><td colspan="5">Sin tarifas en prices.json para técnica: ${techniqueRef || 'N/A'}</td></tr>`;
        return;
      }
      const rows = buildPriceRows(config, button);
      renderRows(tbody, rows);
    } catch (error) {
      console.error('Error construyendo tabla de marcaje:', error);
      tbody.innerHTML = '<tr><td colspan="5">No hay tarifas disponibles para esta técnica.</td></tr>';
    }
  }

  document.querySelectorAll('.tecnica-toggle-button').forEach(button => {
    button.addEventListener('click', async () => {
      const tableDiv = button.nextElementSibling;
      const icon = button.querySelector('.toggle-icon');

      if (tableDiv.style.display === 'none' || tableDiv.style.display === '') {
        tableDiv.style.display = 'block';
        icon.textContent = '-';
        await fillMarkingTable(button);
      } else {
        tableDiv.style.display = 'none';
        icon.textContent = '+';
      }
    });
  });
  

  } catch(e) { console.error(e); }
})();
})();
